import { useState } from 'react';

export function useWixSiteIdForOrgMapping(): [
  string,
  (newSiteId: string) => void,
  () => void,
] {
  // Initialize site ID from localStorage
  const getInitialWixSiteIdForOrgMapping = (): string => {
    return localStorage.getItem('wixSiteIdForOrgMapping') || '';
  };

  const [wixSiteIdForOrgMapping, setWixSiteIdForOrgMapping] = useState<string>(
    getInitialWixSiteIdForOrgMapping(),
  );

  const updateWixSiteIdForOrgMapping = (newSiteId: string): void => {
    localStorage.setItem('wixSiteIdForOrgMapping', newSiteId);
    setWixSiteIdForOrgMapping(newSiteId);
  };

  const removeWixSiteIdForOrgMapping = (): void => {
    localStorage.removeItem('wixSiteIdForOrgMapping');
    setWixSiteIdForOrgMapping('');
  };

  return [
    wixSiteIdForOrgMapping,
    updateWixSiteIdForOrgMapping,
    removeWixSiteIdForOrgMapping,
  ];
}
